var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.549,
    height: 13.528,
    viewBox: "0 0 13.549 13.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "basket-shopping-simple",
    d: "M13.109,5.092a1.688,1.688,0,0,0-1.28-.581h-.051a5.072,5.072,0,0,0-10.082,0H1.662A1.685,1.685,0,0,0-.013,6.44l.6,4.184a3.4,3.4,0,0,0,3.349,2.9H9.556a3.4,3.4,0,0,0,3.349-2.9l.6-4.184A1.7,1.7,0,0,0,13.109,5.092ZM6.737,1.128a3.949,3.949,0,0,1,3.9,3.383h-7.8A3.949,3.949,0,0,1,6.737,1.128Z",
    transform: "translate(0.029)",
    fill: "#387F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMarketplace);
export default __webpack_public_path__ + "static/media/sidebar-marketplace.e5b8dffcd5f7ad533582a6855fece56b.svg";
export { ForwardRef as ReactComponent };